import { 
    Toast, 
    ToastTitle, 
    Toaster, 
    useToastController,
    useId
} from '@fluentui/react-components';
import React, { useState } from 'react';

type ToastPosition = 'top' | 'top-start' | 'top-end' | 'bottom' | 'bottom-start' | 'bottom-end';
type ToastType = 'success' | 'error' | 'warning' | 'info';

interface ToastOptions {
    intent?: ToastType;
    position?: ToastPosition;
}

let dispatchToast: (toast: React.ReactNode, options?: ToastOptions) => void;

export const GlobalToaster: React.FC = () => {
    const toasterId = useId('global-toaster');
    const toastController = useToastController(toasterId);
    const [position, setPosition] = useState<ToastPosition>('bottom-end');
    
    // Store the dispatch function for external use
    dispatchToast = (toast: React.ReactNode, options?: ToastOptions) => {
        const toastPosition = options?.position || 'bottom-end';
        setPosition(toastPosition);
        toastController.dispatchToast(toast, { intent: options?.intent, position: toastPosition });
    };

    return (
        <Toaster 
            offset={{ 
                horizontal: position.includes('top') ? 0 : 20, 
                vertical: position.includes('top') ? 0 : 48 
            }} 
            toasterId={toasterId} 
            position={position}
        />
    );
};

export const showToast = (title: string, type: ToastType = 'success', position: ToastPosition = 'bottom-end') => {
    if (!dispatchToast) {
        console.warn('Toast not initialized');
        return;
    }

    dispatchToast(
        <Toast>
            <ToastTitle>{title}</ToastTitle>
        </Toast>,
        { position, intent: type }
    );
};
